import ApiService from "@/common/api.service"

export const AccreditorService = {
    create(params) {
        return ApiService.post("accreditors/add", params);
    },
    update(slug, params) {
        return ApiService.update("/accreditors", slug, params);
    },
    async getAccreditorList() {
        const res = await ApiService.get("/accreditors");
        return res.data;
    },
    async getAccreditorListWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/accreditors?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data;
    },
    async getAllAccreditorsList() {
        const res = await ApiService.get("/accreditors/lookup/list")
        return res.data;
    },
    async getAccreditorsDrp(params) {
        const res = await ApiService.get(`/accreditors/drp${params}`)
        return res.data;
    },
    async getAccreditorsByLocation(locationId) {
        const res = await ApiService.get(`/accreditors/lookup/list/${locationId}`)
        return res.data.data;
    },
    async getAccreditor(id) {
        const res = await ApiService.get(`/accreditors/${id}`);
        return res.data.data;
    },
    async getRenewals(id) {
        const res = await ApiService.get(`/renewals?accreditorId=${id}`);
        return res.data;
    },
    async addRenewal(params) {
        return ApiService.post("renewals/add", params);
    },
}